import NavigationItemsSlider from "./NavigationItemsSlider.jsx";
import NavigationSecondLevel from "./NavigationSecondLevel.jsx";
import {useEffect, useState} from "react";
import Landmark from '@core/scripts/components/landmark-adapter';
import {useMobileNavigationContext} from "../../context/mobile-navigation-context.jsx";
import {getSlicedLeftSubNavigationItems} from "../../../helper/sub-navigation-helper.js";

export default function NavigationFirstLayer({
                                                 activeFirstLevelIndex,
                                                 setActiveFirstLevelIndex,
                                                 selectSecondLevelItem,
                                                 visible
                                             }) {
    const {navigationItems} = useMobileNavigationContext()

    const [nextActiveFirstLevelIndex, setNextActiveFirstLevelIndex] = useState(null);

    useEffect(() => {
        if (visible) {
            const item = navigationItems[activeFirstLevelIndex];
            const lmValue = {view: `pictureNaviLayer\\${item.id}`};
            Landmark.sendActionLandmark(lmValue);
        }
    }, [visible]);


    const previousSlide = nextActiveFirstLevelIndex != null && nextActiveFirstLevelIndex < activeFirstLevelIndex;
    const nextSlide = nextActiveFirstLevelIndex != null && nextActiveFirstLevelIndex > activeFirstLevelIndex;

    const transition = () => {
        if (previousSlide) {
            return 'swipe-left';
        }
        if (nextSlide) {
            return 'swipe-right';
        }
        return "";
    }

    const nextSlicedLeftSubNavigationItems = getSlicedLeftSubNavigationItems(navigationItems[nextActiveFirstLevelIndex])
    const activeSlicedLeftSubNavigationItems = getSlicedLeftSubNavigationItems(navigationItems[activeFirstLevelIndex])
    return (
        <>
            <NavigationItemsSlider
                items={navigationItems}
                activeIndex={activeFirstLevelIndex}
                setActiveIndex={setActiveFirstLevelIndex}
                setNextActiveIndex={setNextActiveFirstLevelIndex}
            />
            <div className={`navigation__second-level-wrapper`}>
                {previousSlide && (
                    <div className={`navigation__sub-navigation-slide swipe-left`}>
                        <NavigationSecondLevel secondLevelItems={nextSlicedLeftSubNavigationItems} />
                    </div>
                )}
                <div className={`navigation__sub-navigation-slide ${transition()}`}>
                    <NavigationSecondLevel
                        secondLevelItems={activeSlicedLeftSubNavigationItems}
                        selectSecondLevelItem={selectSecondLevelItem}
                        activeFirstLevelIndex={activeFirstLevelIndex}
                    />
                </div>
                {nextSlide && (
                    <div className={`navigation__sub-navigation-slide swipe-right`}>
                        <NavigationSecondLevel secondLevelItems={nextSlicedLeftSubNavigationItems} />
                    </div>
                )}
            </div>
        </>
    );
}